<template>
    <ResourceList :addRoute="null"
                  :key="showPlannedWorkouts ? 'with-planned' : 'without-planned'"
                  :params="params"
                  :query="query"
                  ref="resourceList"
                  :resource="resource"
                  :renderAs="renderAs"
                  title="Workouts"
    >
        <template #headerActions>
            <button
                v-if="!hideAddButton"
                type="button"
                class="flex h-10 w-10 items-center justify-center rounded border border-brand-primary-400 bg-brand-primary-400 text-neutral-900 transition-colors hover:bg-brand-primary-300"
                aria-label="Add workout"
                title="Add workout"
                @click="$router.push(addRoute)"
            >
                <Icon icon="plus" />
            </button>
            <Dropdown
                dropdownClass="absolute right-0 mt-1 w-72 rounded bg-white py-2 text-neutral-900 shadow-lg ring-1 ring-black/5 dark:bg-neutral-900 dark:text-white"
            >
                <template #toggle>
                    <button
                        type="button"
                        class="flex h-10 w-10 items-center justify-center rounded border border-neutral-300 text-neutral-600 transition-colors hover:border-brand-primary-400 hover:text-brand-primary-500 dark:border-neutral-500 dark:text-neutral-300"
                        aria-label="Workout list options"
                        title="Workout list options"
                    >
                        <Icon icon="ellipsis-h" />
                    </button>
                </template>
                <template #dropdown>
                    <div
                        data-cy="planned-workouts-toggle"
                        class="flex items-center justify-between gap-4 px-4 py-2"
                        @click.stop
                    >
                        <label class="cursor-pointer text-sm font-semibold" for="show-planned-workouts">
                            Show planned workouts
                        </label>
                        <Switch
                            id="show-planned-workouts"
                            v-model="showPlannedWorkouts"
                            data-cy="show-planned-workouts"
                        />
                    </div>
                </template>
            </Dropdown>
        </template>
    </ResourceList>
</template>

<script>
import {Workout} from '@/internal';
import WorkoutResourceListItem from '@/components/Workout/ResourceListItem.vue';

export default {
  name: 'WorkoutResourceList',
  data() {
    return {
      resource: Workout,
      showPlannedWorkouts: false,
    };
  },
  computed: {
    params() {
      return {
        include: [
          'exercises',
          'file',
          'template',
        ],
        includeFuture: this.showPlannedWorkouts,
      };
    },
  },
  props: {
    addRoute: {
      default() {
        return window.app.findRouteByName('workout/create');
      },
      required: false,
    },
    hideAddButton: {
      default: false,
      type: Boolean,
    },
    query: {
      default: () => {
      },
      required: false,
    },
    renderAs: {
      default: () => {
        return WorkoutResourceListItem;
      },
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">

</style>
